import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ApiService} from '../../../api.service';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {

  section: {} = [];
  constructor(public restApi: ApiService) { }
  @Input() shaftId: number;

  @Output()
  selectedSectionID: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges) {
    this.loadSection();
  }

  // Get employees list
  loadSection() {
    return this.restApi.getSection(this.shaftId).subscribe((data: {}) => {
      this.section = data;
    });
  }

  onChange(message) {
    this.selectedSectionID.emit(message);
  }

}
